const langMap = {
	pl: 'pl-PL',
	en: 'en-US',
	de: 'de-DE',
	es: 'es-ES',
	cs: 'cs-CZ',
	sk: 'sk-SK',
	hu: 'hu-HU',
	ro: 'ro-RO',
}

export const locales = [
  { name: 'English', value: 'en-US' },
  { name: 'Polski', value: 'pl-PL' },
  { name: 'Deutsch', value: 'de-DE' },
  { name: 'Español', value: 'es-ES' },
  { name: 'Čeština', value: 'cs-CZ' },
  { name: 'Slovenčina', value: 'sk-SK' },
  { name: 'Magyar', value: 'hu-HU' },
  { name: 'Română', value: 'ro-RO' },
]

export function normalizeLang(lang) {
	if (!lang) return ''

	const normalized = lang.toLowerCase().replace(/([a-z]{2})-([a-z]{2})/, (p1, p2) => {
		return `${p1}-${p2.toUpperCase()}`
	})

	if (Object.values(langMap).includes(normalized)) return normalized

	const shortLang = normalized.split('-')[0]
	if (langMap[shortLang]) return langMap[shortLang]

	return ''
}

export function getEffectiveLang() {
  const urlParams = new URLSearchParams(window.location.search)
  const urlLang = urlParams.get('lang')
  const storedLang = localStorage.getItem('lang')
  let lang = urlLang || storedLang || navigator.language || 'pl-PL'
  return normalizeLang(lang)
}

export const supportedLangs = Object.values(langMap)